export default [ '$compile', function($compile) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      let requiredElement = $compile(
        '<span ng-if="required" class="c-form__required"></span>'
      )(scope);

      element.parent()[0].insertBefore(requiredElement[0], element[0]);

      attrs.$observe('required', () => {
        scope.required = attrs.required;
      });
    }
  };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/directives/required.directive.js